export default {
  registerSkipper(context, data) {
    const userId = context.rootGetters.userId;

    var achieved = [];
    var transformedElement;

    data.achieve.forEach(element => {
      if (element == 'vendee_arctique') {
        transformedElement = 'Vendée Arctique';
      } else if (element == 'transat_jacques_vabre') {
        transformedElement = 'Transat Jacques Vabre';
      } else if (element == 'rolex_fastnet_race') {
        transformedElement = 'Rolex Fastnet Race';
      } else if (element == 'route_de_rhum') {
        transformedElement = 'Route de Rhum';
      } else if (element == 'bermudes_1000_race') {
        transformedElement = 'Bermudes 1000 Race';
      } else {
        return false;
      }

      achieved.push(transformedElement);
    });

    const skipperData = {
      firstName: data.first,
      lastName: data.last,
      description: data.desc,
      age: data.age,
      achievements: achieved
    };

    const token = context.rootGetters.token;

    fetch(
      `https://vue-http-demo-6781e-default-rtdb.firebaseio.com/coaches/${userId}.json?auth=` +
        token,
      {
        method: 'PUT',
        body: JSON.stringify(skipperData)
      }
    ).then(res => {
      if (!res.ok) {
        // error ...
      } else {
        return res.json();
      }
    });

    context.commit('addSkipper', { ...skipperData, id: userId });
  },

  async loadSkippers(context, payload) {
    if (!payload.forceRefresh && !context.getters.shouldUpdate) {
      return;
    }

    const response = await fetch(
      `https://vue-http-demo-6781e-default-rtdb.firebaseio.com/coaches.json`
    );

    const data = await response.json();

    if (!response.ok) {
      const error = new Error(data.message || 'Failed to fetch!');
      throw error;
    }

    const skippers = [];

    for (const key in data) {
      const skipper = {
        id: key,
        firstName: data[key].firstName,
        lastName: data[key].lastName,
        description: data[key].description,
        age: data[key].age,
        achievements: data[key].achievements
      };
      skippers.push(skipper);
    }
    context.commit('setSkippers', skippers);
    context.commit('setFetchTimestamp');
  }
};
